/**
 * Per-locale data loaders. Both endpoints sit under `./api/` (relative to
 * the deployed `/play/`) since Vite's `publicDir: 'static'` copies the
 * curator-generated `static/api/*.json` files into `dist/api/`.
 *
 * Graphs are cached in-memory once loaded — switching ladders inside a
 * world only triggers a fetch if the word length changes.
 */
import type { AdjacencyList, LaddersFile, Locale } from './types';

const graphCache = new Map<string, AdjacencyList>();

export async function loadLadders(locale: Locale): Promise<LaddersFile | null> {
  try {
    const res = await fetch(`./api/ladders-${locale}.json`);
    if (!res.ok) return null;
    return (await res.json()) as LaddersFile;
  } catch {
    return null;
  }
}

export async function loadGraph(locale: Locale, length: number): Promise<AdjacencyList> {
  const key = `${locale}|${length}`;
  const cached = graphCache.get(key);
  if (cached) return cached;
  const res = await fetch(`./api/graph-${locale}-${length}.json`);
  const data = (await res.json()) as Record<string, string[]>;
  const map: AdjacencyList = new Map(Object.entries(data));
  graphCache.set(key, map);
  return map;
}
